import { type AdyenFlagObject } from '@quickmd-llc/design-system';
import { LegacyVerifiedOptions } from '@types';
import { StateCreator } from 'zustand';

const FLAGS_SET_FLAGS = 'FLAGS_SET_FLAGS';
interface MHTStatesProp {
  states: string[];
}

interface IdVerificationOptions {
  liveness: string;
  numForceRetries: number;
  idLiveness: string;
  manualCaptureTimeout: number;
  showTermsAndPrivacy: boolean;
  idCaptureType: string;
}

export interface FlagsState {
  // !!this is not a flag, but it's used to track if the flags have been fetched yet
  flagsHaveBeenFetched: boolean;
  appointmentBufferMinutes: number;
  experimentCuratedAppointmentSlots: boolean;
  experimentCuratedAppointmentSlotsEnabled: boolean;
  experimentMatQuestions: boolean;
  experimentMatQuestionsEnabled: boolean;
  idVerificationOptions: IdVerificationOptions;
  legacyVerifiedOptions: LegacyVerifiedOptions;
  newBookingBanner: boolean;
  useProviderVisibility: boolean;
  visitTranscriptConsent: boolean;
  adyen: AdyenFlagObject;
  mhtStates: MHTStatesProp;
  pharmacySearchDaw: boolean;
}

export interface FlagsActions {
  setFlags: (flagData: Partial<FlagsState>) => void;
}

export type FlagsSlice = {
  flags: FlagsState & FlagsActions;
};

export const initialState: FlagsState = {
  // !!this is not a flag, but it's used to track if the flags have been fetched yet
  flagsHaveBeenFetched: false,
  legacyVerifiedOptions: {
    isActive: false,
    states: [],
  },
  idVerificationOptions: {
    idCaptureType: 'camera',
    liveness: 'enhanced',
    numForceRetries: 2,
    idLiveness: 'distance',
    manualCaptureTimeout: 20000,
    showTermsAndPrivacy: true,
  },
  newBookingBanner: false,
  useProviderVisibility: false,
  appointmentBufferMinutes: 10,
  experimentCuratedAppointmentSlots: false,
  experimentCuratedAppointmentSlotsEnabled: false,
  experimentMatQuestions: false,
  experimentMatQuestionsEnabled: false,
  visitTranscriptConsent: false,
  adyen: {
    enabled: false,
    only_enabled_for_users_created_after: null,
    enabled_user_ids: [],
  },
  mhtStates: { states: [] },
  pharmacySearchDaw: false,
};

export const createFlagsSlice: StateCreator<
  FlagsSlice,
  [['zustand/devtools', never]]
> = (set) => ({
  flags: {
    ...initialState,
    setFlags: (data) => {
      set(
        (state) => {
          return {
            flags: {
              ...state.flags,
              ...data,
              flagsHaveBeenFetched: true,
            },
          };
        },
        false,
        FLAGS_SET_FLAGS,
      );
    },
  },
});
